import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import Result from '../../_interface/result';
import { ResourceInfo } from '../../_interface/appinfo-int';
import NebulaModuleBase from './module-base';
import ExecutionResult from '../../uplus-api/container/execution-result';
export var Appinfo = function (_NebulaModuleBase) {
    _inherits(Appinfo, _NebulaModuleBase);

    function Appinfo() {
        _classCallCheck(this, Appinfo);

        return _possibleConstructorReturn(this, (Appinfo.__proto__ || Object.getPrototypeOf(Appinfo)).apply(this, arguments));
    }

    _createClass(Appinfo, [{
        key: 'getResourceInfo',
        value: function getResourceInfo() {
            return new Promise(function (resolve, reject) {
                window.AlipayJSBridge.call('getStartupParams', {
                    key: ['url']
                }, function (ret) {
                    window.console.info('bridge.call getStartupParams ' + JSON.stringify(ret));
                    var URL_HOST = ret.url;
                    if (URL_HOST.indexOf('file://') === -1) {
                        // 处理外部链接
                        var resInfo = new ResourceInfo();
                        resInfo.resName = window.location.href.split('?')[0] || '';
                        resInfo.resVersion = '';
                        resolve(new Result('000000', '', resInfo));
                    } else {
                        // 处理资源包
                        var url = URL_HOST.replace('https://virtual.uplus.com/', '');
                        var position = url.indexOf('mPaaS/');
                        if (position !== -1) {
                            var info = url.substr(position).replace('mPaaS/', '');
                            var subPosition = info.indexOf('/');
                            if (subPosition !== -1) {
                                info = info.substring(0, subPosition);
                                info = unescape(info);
                                var _resInfo = info.split('@');
                                var resourceInfo = new ResourceInfo();
                                resourceInfo.resName = _resInfo[0];
                                resourceInfo.resVersion = _resInfo[1];
                                resolve(new Result('000000', '', resourceInfo));
                            } else {
                                reject(new ExecutionResult('000001'));
                            }
                        } else {
                            reject(new ExecutionResult('000001'));
                        }
                    }
                });
            });
        }
    }, {
        key: 'getApplicationCacheSize',
        value: function getApplicationCacheSize() {
            return this.generatePromiseByFunctionWithParams('getCacheSizeForAppInfo', null);
        }
    }, {
        key: 'cleanApplicationCache',
        value: function cleanApplicationCache() {
            return this.generatePromiseByFunctionWithParams('cleanCacheForAppInfo', null);
        }
    }, {
        key: 'getAppInfo',
        value: function getAppInfo() {
            return this.generatePromiseByFunctionWithParams('getAppInfoForAppInfo', null);
        }
    }, {
        key: 'getPhoneInfo',
        value: function getPhoneInfo() {
            return this.generatePromiseByFunctionWithParams('getPhoneInfoForAppInfo', null);
        }
    }, {
        key: 'isGrayMode',
        value: function isGrayMode() {
            return this.generatePromiseByFunctionWithParams('isGrayModeForAppInfo', null);
        }
    }, {
        key: 'setGrayMode',
        value: function setGrayMode(params) {
            return this.generatePromiseByFunctionWithParams('setGrayModeForAppInfo', params);
        }
    }]);

    return Appinfo;
}(NebulaModuleBase);